export const LARGE = '?d=480x480';
export const MEDIUM = '?d=200x200';
export const THUMBNAIL = '?d=80x80';
export const TINY = '?d=50x50';

export const MAX_HEIGHT_UPLOAD = 1024;
export const MAX_WIDTH_UPLOAD = 1024;
export const COMPRESSION_QUALITY = 90;
